export default __webpack_public_path__ + "static/media/p_wdt_c_6.a55cd74b.mp3";